import type { IconSvgObject } from './types';

const EyeOffIcon: IconSvgObject = [
  ["path", { d: "M10.1504 5.1504C10.73 5.05323 11.346 5 12 5C19.5 5 22 12 22 12C22 12 21.4602 13.5115 20.1297 15.1297M6.51987 6.51987C3.22188 8.57873 2 12 2 12C2 12 4.5 19 12 19C14.2567 19 16.0607 18.3662 17.4801 17.4801", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.87868 9.87868C9.33579 10.4216 9 11.1716 9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default EyeOffIcon;
